import React from "react";
import {
  Grid,
  Typography,
  Box,
  useTheme,
  Card,
  CircularProgress,
} from "@mui/material";
import DonutLargeOutlinedIcon from "@mui/icons-material/DonutLargeOutlined";

const placeholderCardSx = (theme) => ({
  borderRadius: 2,
  boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
  border: `1px solid ${theme.palette.divider}`,
  backgroundColor: theme.palette.background.paper,
  minHeight: 420,
});

const FundAllocatorEmptyState = () => {
  const theme = useTheme();

  return (
    <Grid size={{ xs: 12 }}>
      <Card
        sx={{
          ...placeholderCardSx(theme),
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <Box
          sx={{
            textAlign: "center",
            px: 4,
            py: 6,
            maxWidth: 480,
          }}
        >
          <Box
            sx={{
              width: 80,
              height: 80,
              borderRadius: "50%",
              backgroundColor:
                theme.palette.mode === "dark"
                  ? "rgba(255,255,255,0.06)"
                  : theme.palette.grey[100],
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              mx: "auto",
              mb: 2.5,
            }}
          >
            <DonutLargeOutlinedIcon
              sx={{
                fontSize: 40,
                color: theme.palette.text.secondary,
              }}
            />
          </Box>
          <Typography
            sx={{
              fontSize: "20px",
              fontWeight: 700,
              color: theme.palette.text.primary,
              mb: 1,
            }}
          >
            Select a fund to begin
          </Typography>
          <Typography
            sx={{
              fontSize: "14px",
              color: theme.palette.text.secondary,
              lineHeight: 1.6,
            }}
          >
            Choose a fund from the dropdown above to view allocation summaries,
            strategy breakdowns, and target preferences.
          </Typography>
        </Box>
      </Card>
    </Grid>
  );
};

const FundAllocatorLoadingState = () => {
  const theme = useTheme();

  return (
    <Grid size={{ xs: 12 }}>
      <Card
        sx={{
          ...placeholderCardSx(theme),
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          gap: 2,
        }}
      >
        <CircularProgress size={40} />
        <Typography
          sx={{
            fontSize: "14px",
            color: theme.palette.text.secondary,
          }}
        >
          Loading fund allocations…
        </Typography>
      </Card>
    </Grid>
  );
};

const FundAllocatorContentState = ({
  hasFundSelected,
  showFundLoader,
  children,
}) => {
  if (!hasFundSelected) {
    return <FundAllocatorEmptyState />;
  }

  if (showFundLoader) {
    return <FundAllocatorLoadingState />;
  }

  return children;
};

export default FundAllocatorContentState;
